var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',[_c('b-table',{attrs:{"bordered":"","hover":"","responsive":"","fields":_vm.fields}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }